export enum PassOrFail {
    PASS = 'PASS',
    FAIL = 'FAIL',
}
export enum AllocatedLab{
    INHOUSE = 'INHOUSE',
    EXTERNAL = 'EXTERNAL'
}